export enum MetaType {
    None = 0,
    AgencyLogo,
    VendorLogo,
    TermsAndConditions,
    Genetics,
}
